import { post, get } from '@/utils/httpHelper';
import CookiesHelper from '@/utils/cookiesHelper';

const LOGIN_URL = `/esg/login`;
export default {
  async login (params) {
    var result;
    await post(LOGIN_URL, params).then(function (data) {
      // save token info in cookie
      if (data) {
        CookiesHelper.set('JWT-TOKEN-HEADER', 'Bearer ' + data.data.data['accessToken']['rawToken']);
        CookiesHelper.set('JWT-TOKEN-REFRESH', 'Bearer ' + data.data.data['refreshToken']['rawToken']);
        CookiesHelper.set('JWT-ROLE', data.data.data['accessToken']['claims']['scopes'][0]);
        CookiesHelper.set('USER_NAME', data.data.data['accessToken']['claims']['sub']);
      }
      result = data;
    })
    return result;
  },
  async getPublicKey () {
    const url = `/esg/rsa/publicKey`;
    const body = await get(url);
    return body.data;
  },
  async verifyUserInfo () {
    const url = `/esg/security/auth/userInfo`;
    const body = await get(url);
    return body.data;
  },
  async setIP (loginLog) {
    const url = `/esg/security/auth/setIP`;
    const body = await post(url, loginLog);
    return body.data;
  }
}



// WEBPACK FOOTER //
// ./src/repositories/auth/auth.js